var all_coffee_data = []
var coffee_model = {
  title:null,
  batch_number:null,
  batch_date:null,
  charge_temp:null,
  finish_temp:null,
  batch_size:null,
  cup_score:null,
  roast_time:null,
  cup_notes:null,
  pdp_url:null,
  machine:null,
  weight_loss:null,
  temp_curves:null,
  roast_value:null,
  roast_profile:null,
  roaster: {
    name:null,
    title:null,
    profile:null,
    signature:null,
    about:null,
    accolades:null
  }
}



rivets.binders.src = function(el, value) {
  if (value)
  	el.src = value;
};
rivets.bind($('.coffee-deet'), {coffee: coffee_model})



$(document).on("click",".show-sample", function(){
  $("#batch_id").val("65594")
	get_coffee_data()
})



$(document).on("click",".do-coffee-lookup", function(){
	get_coffee_data()
})
$("#batch_id").keyup(function(event) {
    if (event.keyCode === 13) {
        get_coffee_data()
    }
});

function findFiveOrSixDigitNumber(str) {
  const match = str.match(/\d{5,6}/);
  return match ? match[0] : null;
}


if (get_query_variable("id")) {

  var batch_id = get_query_variable("id")
  var clean_id = findFiveOrSixDigitNumber(batch_id)

  console.log("Cleaned:" + clean_id)

  if (!batch_id){
    alert("We couldn't find that batch. Try using the 5 or 6-digit code on the bottom of your box. If all else fails, send us an email and we'll make it right!")
  }
  else {
    $("#batch_id").val(clean_id)
    get_coffee_data()
  }


}


async function get_coffee_data(){


  $(".intro").addClass("loading")


  //get the input
  var batch_no = $("#batch_id").val()

  //validate input
  if (!batch_no){
    alert("Please enter your batch number")
    $(".intro").removeClass("loading")
    return
  }


  var base_url = "https://onyx-data.herokuapp.com/api/cropster/find-my-roast?id=" + batch_no
  const base_resp = await fetch(base_url);
  const base_resp_json = await base_resp.json()

  if (base_resp_json.error){
    alert("We couldn't find that batch!")
    $(".intro").removeClass("loading")
    return
  }

  if (!base_resp_json.batch.batch_number){
    alert("We couldn't find that batch!")
    $(".intro").removeClass("loading")
    return
  }
  else {

    //console.log("server response:")
    console.log(base_resp_json)

    //fade out the initial model
    $(".intro").addClass("loading")

  }


  set_query_variable("id", batch_no)

  console.log(base_resp_json.batch.roaster)
  var roaster_name = base_resp_json.batch.roaster || "Dakota"

  var profile_id = ""
  if (base_resp_json.batch.profile_id){
    profile_id = base_resp_json.batch.profile_id
  }


  var urls = [
    {
      name:"product",
      url:"https://product.onyxcontent.com/find-my-roast?profile=" + profile_id
    },
    {
      name:"roaster",
      url:"https://people.onyxcontent.com/roasters/" + roaster_name.toLowerCase() + ".json"
    }
  ]
  const responses = await Promise.all(urls.map(async url => {
    const resp = await fetch(url.url);
    return {name:url.name, result: await resp.json()}
  }));



  var coffee_resp_json = {}
  var roaster_resp_json = {}
  if (responses[0].name == "product"){
    coffee_resp_json = responses[0].result
    roaster_resp_json = responses[1].result
  }
  else if (responses[0].name == "roaster"){
    coffee_resp_json = responses[1].result
    roaster_resp_json = responses[0].result
  }
  else {
    console.log("what?")
    console.log(responses[0].name)
  }


  // console.log(coffee_resp_json)
  // console.log(roaster_resp_json)
  // return;

  // var coffee_url = "https://retail.onyxcontent.com/product-fuzzy-match?batch_name=" + base_resp_json.batch.lot_name
  // const coffee_resp = await fetch(coffee_url);
  // const coffee_resp_json = await coffee_resp.json()
  //
  // console.log(coffee_resp_json)


  coffee_model.title = coffee_resp_json.title
  coffee_model.batch_number = String(base_resp_json.batch.batch_number)

  coffee_model.temp_curves = base_resp_json.curves
  coffee_model.batch_data = base_resp_json.batch.data || []

  var agtron_score_ground = coffee_resp_json.agtron_score_ground || coffee_resp_json.agtron
  coffee_model.roast_value = base_resp_json.batch.roast_value
  coffee_model.roast_profile = agtron_map(agtron_score_ground)

  coffee_model.charge_temp = base_resp_json.batch.start_temp
  coffee_model.machine = base_resp_json.batch.machine
  coffee_model.weight_loss = (parseFloat(base_resp_json.batch.start_weight) - parseFloat(base_resp_json.batch.end_weight)) / parseFloat(base_resp_json.batch.start_weight) * 100
  coffee_model.finish_temp = base_resp_json.batch.end_temp
  coffee_model.roast_time = (base_resp_json.batch.duration / 1000 / 60).toFixed(1)
  coffee_model.batch_size = parseFloat(base_resp_json.batch.start_weight)

  coffee_model.cup_score = coffee_resp_json.cup_score
  coffee_model.cup_notes = coffee_resp_json.cup_notes
  coffee_model.qc_notes = ""

  coffee_model.batch_date = ""

  coffee_model.pdp_url = "/products/" + coffee_resp_json.shopify_slug



  coffee_model.roaster.name = roaster_resp_json.name
  coffee_model.roaster.title = roaster_resp_json.title
  coffee_model.roaster.pic = roaster_resp_json.pic
  coffee_model.roaster.about = roaster_resp_json.blurb
  coffee_model.roaster.sig = roaster_resp_json.sig
  coffee_model.roaster.accolades = roaster_resp_json.accolades


  display_coffee(coffee_model)


}


function display_coffee(coffee_data){

  setup_chart(coffee_data)
  //$(".primary-spacer").addClass("disabled")
  $(".intro").addClass("inactive")

  $(".bg-video").addClass("dark")


  setTimeout(function(){
    $(".coffee-deet").addClass("active")
  }, 300)

}


function agtron_map(raw_score){
  raw_score = parseFloat(raw_score)

  if (Number.isNaN(raw_score)){
    return "Unknown"
  }
  else if (raw_score <= 93){
    return "Dark"
  }
  else if (raw_score > 93 && raw_score <= 105){
    return "Expressive Dark"
  }
  else if (raw_score > 105 && raw_score <= 127){
    return "Moderate"
  }
  else if (raw_score > 127 && raw_score <= 130){
    return "Light"
  }
  else if (raw_score > 130){
    return "Ultra Light"
  }
  else {
    return "Unknown"
  }
}

function setup_chart(coffee_data){


  if (!coffee_data.batch_data || !coffee_data.batch_data.length) {
    $("#chart-container").hide()
    return
  }
  else {
    $("#chart-container").show()
  }


  //do amcharts stuff here
  am5.ready(function() {

    var raw_data = coffee_data.batch_data || []

    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    window.chart_root = am5.Root.new("chartdiv");


    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    chart_root.setThemes([
      am5themes_Animated.new(chart_root)
    ]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = chart_root.container.children.push(am5xy.XYChart.new(chart_root, {
      maxTooltipDistance: 5
    }));






    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(chart_root, {
      baseInterval: {
        timeUnit: "second",
        count: 1
      },
      strictMinMax: true,
      renderer: am5xy.AxisRendererX.new(chart_root, {}),
      tooltip: am5.Tooltip.new(chart_root, {})
    }));

    let xRenderer = xAxis.get("renderer");
    xRenderer.labels.template.setAll({
      fill: am5.color(0xAAAAAA),
      fontSize: "0.8em"
    });
    xAxis.set("tooltip", am5.Tooltip.new(chart_root, {
      forceHidden: true
    }));

    var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(chart_root, {
      renderer: am5xy.AxisRendererY.new(chart_root, {})
    }));
    let yRenderer = yAxis.get("renderer");
    yRenderer.grid.template.setAll({
      stroke: am5.color(0xDDDDDD),
      strokeWidth: 2
    });
    yRenderer.labels.template.setAll({
      fill: am5.color(0xAAAAAA),
      fontSize: "0.8em"
    });

    // Build bean data from raw batch data (same as coffee PDP)
    var beanData = [];
    for (var i = 0; i < raw_data.length; i++) {
      beanData.push({ time: i, value: (raw_data[i] / 10) });
    }

    function calculateRateOfRise(series, options = {}) {
      const result = [];
      for (let i = 1; i < series.length; i++) {
        const prev = series[i - 1];
        const curr = series[i];
        const deltaTime = curr.time - prev.time;
        const deltaValue = curr.value - prev.value;
        var rate = deltaTime !== 0 ? deltaValue / deltaTime : 0;
        if (rate < 0) rate = 0;
        result.push({ time: curr.time, value: (rate * 30.0) });
      }

      if (options.smooth && options.windowSize && options.windowSize > 1) {
        const smoothed = [];
        const w = options.windowSize;
        for (let i = 0; i < result.length; i++) {
          let sum = 0;
          let count = 0;
          for (let j = i - Math.floor(w / 2); j <= i + Math.floor(w / 2); j++) {
            if (j >= 0 && j < result.length) {
              sum += result[j].value;
              count++;
            }
          }
          smoothed.push({
            time: result[i].time,
            value: Math.round((sum / count) * 10) / 10
          });
        }
        return smoothed;
      }
      return result;
    }

    var ror_data = calculateRateOfRise(beanData, { smooth: true, windowSize: 30 });


    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var tooltip = am5.Tooltip.new(chart_root, {
      getFillFromSprite: false,
      pointerOrientation: "horizontal",
      labelText: "[fontFamily: Andale]{valueY}°F\n{valueX} Sec.[/]",
      autoTextColor: false
    })
    tooltip.get("background").setAll({
      fill: am5.color(0x000000),
      fillOpacity: 0.3,
      strokeOpacity: 0.0
    });
    tooltip.label.setAll({
      fill: am5.color(0xA57044)
    });
    var series = chart.series.push(am5xy.SmoothedXLineSeries.new(chart_root, {
      name: "Bean Temp",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      valueXField: "time",
      stroke: am5.color(0xA57044),
      legendValueText: "{valueY}",
      tooltip: tooltip
    }));

    series.data.setAll(beanData);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear();







    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/

    var tooltip1 = am5.Tooltip.new(chart_root, {
      getFillFromSprite: false,
      pointerOrientation: "horizontal",
      labelText: "[fontFamily: Andale] {valueY}Δ°F/s\n{valueX} Sec.[/]",
      autoTextColor: false
    })
    tooltip1.get("background").setAll({
      fill: am5.color(0x000000),
      fillOpacity: 0.3,
      strokeOpacity: 0.0
    });
    tooltip1.label.setAll({
      fill: am5.color(0xa12f30)
    });
    var yAxis1 = chart.yAxes.push(am5xy.ValueAxis.new(chart_root, {
      renderer: am5xy.AxisRendererY.new(chart_root, {opposite: true})
    }));
    let yRenderer1 = yAxis1.get("renderer");
    yRenderer1.grid.template.setAll({
      stroke: am5.color(0xDDDDDD),
      strokeWidth: 2
    });
    yRenderer1.labels.template.setAll({
      fill: am5.color(0xAAAAAA),
      fontSize: "0.8em"
    });

    var series2 = chart.series.push(am5xy.SmoothedXLineSeries.new(chart_root, {
      name: "RoR Temp",
      xAxis: xAxis,
      yAxis: yAxis1,
      valueYField: "value",
      valueXField: "time",
      stroke: am5.color(0xA12F30),
      legendValueText: "{valueY}",
      tooltip:tooltip1
    }));


    series2.data.setAll(ror_data);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series2.appear();








    // Add cursor
    var cursor = chart.set("cursor", am5xy.XYCursor.new(chart_root, {
      behavior: "none"
    }));
    cursor.lineY.set("visible", false);

    cursor.lineX.setAll({
      stroke: am5.color(0xAAAAAA),
      strokeWidth: 1,
      strokeDasharray: []
    });
    cursor.selection.setAll({
      fill: am5.color(0x000055),
      fillOpacity: 0.2
    });



    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    // var legend = chart.leftAxesContainer.children.unshift(am5.Legend.new(root, {
    //   width: 200,
    //   paddingLeft: 15,
    //   height: am5.percent(100)
    // }));



    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);

  }); // end am5.ready()

}


$(".reset-form").click(function(){


  $(".coffee-deet").removeClass("active")
  $(".intro").removeClass("loading")

  window.chart_root.dispose()


  window.scrollTo(0,0);


  setTimeout(function(){
    $(".intro").removeClass("inactive")

  	$(".bg-video").removeClass("dark")
  }, 300)
})
